module.exports = __webpack_public_path__ + "static/img/partnerLogoTwo.d79a363.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pageThree/partnerLogoTwo.png
// module id = t4NF
// module chunks = 0